import type { Locale } from "./locales";
import deDictionaries from "./de-DE/translation.json";
import enDictionaries from "./en-GB/translation.json";
import esDictionaries from "./es-ES/translation.json";
import frDictionaries from "./fr-FR/translation.json";
import itDictionaries from "./it-IT/translation.json";
import { defaultLocale, locales } from "./locales";
import nlDictionaries from "./nl-NL/translation.json";

export const name = "dictionaries";

// Re-exported from the JSON-free `./locales` module so consumers can keep
// importing them from the package root, while server bundles that only need
// the list can import `@ergon-ai/dictionaries/locales` and skip the JSON.
export { defaultLocale, locales, type Locale };

export type TranslationValue =
  | string
  | number
  | boolean
  | Date
  | null
  | undefined
  | { [key: string]: TranslationValue }
  | TranslationValue[];

// TranslationValues allows for nested structures (recursive type).
export interface TranslationValues {
  [key: string]: TranslationValue | TranslationValues;
}

export type LocalesResources = Record<
  Locale,
  { translation: TranslationValues }
>;

// Explicitly cast these imports to match TranslationValues
const deDictionariesTyped: TranslationValues = deDictionaries;
const enDictionariesTyped: TranslationValues = enDictionaries;
const esDictionariesTyped: TranslationValues = esDictionaries;
const frDictionariesTyped: TranslationValues = frDictionaries;
const itDictionariesTyped: TranslationValues = itDictionaries;
const nlDictionariesTyped: TranslationValues = nlDictionaries;

export const getLocales = (): LocalesResources => ({
  "en-GB": { translation: enDictionariesTyped },
  "it-IT": { translation: itDictionariesTyped },
  "de-DE": { translation: deDictionariesTyped },
  "nl-NL": { translation: nlDictionariesTyped },
  "fr-FR": { translation: frDictionariesTyped },
  "es-ES": { translation: esDictionariesTyped },
});

export { default as deDictionaries } from "./de-DE/translation.json";
export { default as enDictionaries } from "./en-GB/translation.json";
export { default as esDictionaries } from "./es-ES/translation.json";
export { default as frDictionaries } from "./fr-FR/translation.json";
export { default as itDictionaries } from "./it-IT/translation.json";
export { default as nlDictionaries } from "./nl-NL/translation.json";

export {
  auditKeyMap,
  collectSectionKeys,
  resolveTranslationKey,
  type KeyMapAudit,
} from "./keyAudit";

export {
  getTranslatedDate,
  getRelativeTime,
  getFormattedDateRange,
  getFormattedRelativeDate,
  getFormattedDate,
  getChatTimestamp,
} from "./helpers";
